import { useContext } from "react";
import { Trans, useTranslation } from "react-i18next";
import Typography from "@material-ui/core/Typography";
import PnoSvg from "assets/images/contratSignee.svg";

import { BoxRecap } from "@/views/PolicePno/Souscription/Etapes/Recapitulatif/BoxRecap";
import { UserContext } from "@/contexts/user";

export const Signature = () => {
  // @ts-ignore
  const [userState] = useContext(UserContext);
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="h6">{t("pno.titrePageSignature")}</Typography>

      <section>
        <section style={{ display: "flex", alignItems: "center" }}>
          <img src={PnoSvg} alt="Contrat PNO" />
          <Typography style={{ marginLeft: "20px", marginRight: "10px" }}>
            {t("pno.confirmationEnvoiEmailSignature")}
          </Typography>
          <BoxRecap
            titre={t("pno.coordonéesSignature")}
            sousTitre1={userState.email || "-"}
            sousTitre2={localStorage.getItem("NUM_TEL_GEST") || "-"}
            isEditable={false}
          />
        </section>
        <div
          style={{
            padding: "10px",
            textAlign: "center",
            borderRadius: "10px",
            backgroundColor: "#ff9100",
            width: "320px",
            marginLeft: "auto",
          }}
        >
          <Typography style={{ color: "white", fontSize: 18 }}>
            <Trans i18nKey="pno.signature.rappel" />
          </Typography>
        </div>
      </section>
    </>
  );
};
